import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataSummaryStore } from 'src/app/features/questionnaires/store/data-summary-store';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { QueDatePipe } from 'src/app/pipes/date.pipe';
import { DataSummaryApiService } from 'src/app/features/questionnaires/services/data-summary-api-service';
import { EReplyStatus, Recipient } from 'src/app/models/recipients.model';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { RecipientsStatusMenuComponent } from '../recipients-status-menu/recipients-status-menu.component';
import { StatusRecipientsItemComponent } from '../status-recipients-item/status-recipients-item.component';

@Component({
    selector: 'que-answered-the-questionnaire',
    imports: [CommonModule, TranslateDirective, TranslatePipe, QueDatePipe, RecipientsStatusMenuComponent, StatusRecipientsItemComponent],
    templateUrl: './answered-the-questionnaire.component.html',
    styleUrls: ['./answered-the-questionnaire.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AnsweredTheQuestionnaireComponent implements OnInit {
  id?: number;
  #dataStore = inject(DataSummaryStore);
  notStartedAnsweredTheQuestionnaire$ = toSignal(this.#dataStore.notStartedAnsweredTheQuestionnaire$);
  finishAnsweredTheQuestionnaire$ = toSignal(this.#dataStore.finishAnsweredTheQuestionnaire$);
  InProgressAnsweredTheQuestionnaire$ = toSignal(this.#dataStore.InProgressAnsweredTheQuestionnaire$);
  loadingStatusAnswered$ = toSignal(this.#dataStore.loadingStatusAnswered$);
  name$ = toSignal(this.#dataStore.name$);
  id$ = toSignal(this.#dataStore.currentId$);
  #dataSummaryApiService = inject(DataSummaryApiService)

  isOpenMenu = false;
  constructor() {
    this.#dataStore.updateDisplayState("answeredTheQuestionnaire");
  }

  ngOnInit(): void {

  }

  eReplyStatus = EReplyStatus;
}